/*Copy*/
import { Routes, Route, useNavigate } from "react-router-dom";
import React, { useState, useEffect} from 'react';
import { useContext } from "react";
import './App.css';
import 'tailwindcss/tailwind.css';
import { isTokenValid } from "./api/auth";




// Import Pages
import Home from './pages/Home';
import CurbIT from './pages/CurbIT';
import SearchIT from './pages/SearchIT';
import Feed from './pages/Feed';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import SignOut from './pages/SignOut';
import Splash from './pages/Splash';


// Import Components
import Nav from './components/Nav';

// Import Contexts
import { AuthContext } from './context/AuthContextComponent'

function getCurrentRoute() {
  const path = window.location.pathname;
  return path;
}

function App() {
  const { isLoggedIn, user } = useContext(AuthContext)
  const [tokenTimeout, setTokenTimeout] = useState(false)
  const navigate = useNavigate()
  const route = getCurrentRoute()

  isTokenValid()
  .then((response) => {
    setTokenTimeout(false)
    localStorage.setItem('user', user)
    localStorage.setItem('userId', response.userId)
  })
  .catch(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('userId')
    setTokenTimeout(true)
  })
  

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token && route !== "/auth/signup" && route !== "/auth/signin") {
      navigate('/auth/signin')
    } else if (token && route === "/") {
      navigate('/home')
    }
  }, [tokenTimeout])

  return (
    <div
    className="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat min-h-screen"
    style={{ backgroundImage: "url('/images/bg-image-color.jpg')" }}
  >
        <Nav />
        {/* TODO */}
        <div className="mx-auto">
        <Routes>
              <Route path="/" element={<Splash />} />
              <Route path="/auth/signup/" element={<SignUp />} />
              <Route path="/auth/signin/" element={<SignIn />} />
              {isLoggedIn &&
                <>
                  <Route path="/home/" element={<Home />} />
                  <Route path="/curb-it/" element={<CurbIT />} />
                  <Route path="/curb-success/" />
                  <Route path="/search-categories" element={<SearchIT />} />
                  <Route path="/get-listings" element={<Feed />} />
                  <Route path="/get-listings/category/:category" element={<Feed />} />
                  <Route path="/auth/signout/" element={<SignOut />} />
                </>
              }
            </Routes>
        </div>
    </div>
  );
}

export default App;

